export const MARK_OFFER_AVAILABLE = "MARK_OFFER_AVAILABLE";
export const MARK_OFFER_PROVIDED = "MARK_OFFER_PROVIDED";
export const SAVE_OFFER_DATA = "SAVE_OFFER_DATA";
export const REMOVE_OFFER_DATA = "REMOVE_OFFER_DATA";

export const SET_LAUNCH_OFFERS_PARAMETER = "SET_LAUNCH_OFFERS_PARAMETER";
export const SET_DISABLE_LAUNCH_EVENTS = "SET_DISABLE_LAUNCH_EVENTS,";


// WEBPACK FOOTER //
// ./modules/launch-offers-post-message-handling/actions/actionTypes.ts